<template>
    <div class="items-on-sale">
        <div v-show="loading" style="text-align: center; padding: 25px 0; padding-bottom: 0;">
            <inline-loader></inline-loader>
        </div>
        <v-container grid-list-md fluid class="prod-bg">
            <div class="item-on-sale__swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="product in products.data" :key="product.id" @click="redirectToProduct(product.id)">
                        <div class="product-item">
                            <div class="product-item__content">
                                <div class="product-item__img" @click="redirectToProduct(product.id)">
                                    <v-img :src="product.primary_image" lazy-src="https://digima.sgp1.digitaloceanspaces.com/mybarko/item-placeholder.svg"
                                        contain aspect-ratio="1.2"></v-img>
                                    <!-- <sale-tag v-if="product.primary_image != ''">
                                    <div class="percent">50%</div>
                                    <div class="off">OFF</div>
                                </sale-tag> -->
                                </div>
                                <div class="product-item__details">
                                    <div class="product-item__details-name substr">{{ product.name }}</div>
                                    <div class="product-item__details-price">
                                        <div class="sale">{{product.price_range}}</div>
                                        <!-- <div class="prev-price" >P 50.00</div> -->
                                    </div>
                                </div>
                                <!--<div class="product-item__rating">-->
                                <!--<heart></heart>-->
                                <!--<rating-star :rating="product.id"></rating-star>-->
                                <!--</div>-->
                                <v-btn depressed dark small block class="text-capitalize ma-0 pa-0" color="secondary">Buy
                                    Now</v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
    import Swiper from "swiper";
    import BaseClass from "../BaseClass";
    import {storeProducts} from "../storeProducts";
    export default {
        extends: BaseClass,
        data() {
            return {
                products: [],
                loading : false,
            }
        },
        methods: {
            redirectToProduct(id) {
                this.$router.push({
                    path: '/product/' + id,
                })
            },
            async getList() {

                // if (storeProducts.state.products !== null){
                //     this.products = storeProducts.state.products;
                //     return;
                // }

                this.loading = true
                await axios.get(`/api/g/product?page=1&limit=6`)
                    .then(response => {
                        this.products = response.data.data
                        this.products.data.forEach((data, key) => {
                            if (data.galleries.length) {
                                this.products.data[key].primary_image = data.galleries[0].url_thumbnail
                            } else {
                                this.products.data[key].primary_image = ""
                            }
                            this.products.data[key].price_range = this.getPriceRange(data.variations)
                        })
                    })
                    .catch(err => {
                        if (err.response.data.message === "Server Error"){
                            this.getList();
                            return;
                        }
                        this.toaster('something went wrong.', 201);
                    })
                    .finally(() => {
                        this.loading = false
                        this.loadSwiper()
                    });

                // storeProducts.commit('store_products', this.products);
            },
            loadSwiper() {
                let swiper = new Swiper(".item-on-sale__swiper", {
                    slidesPerView: 5,
                    spaceBetween : 16,
                    freeMode     : true,
                    autoplay     : {
                        delay               : 3000,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 3,
                            spaceBetween: 10,
                        },
                        380: {
                            slidesPerView: 3,
                            spaceBetween: 8,
                        },
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                        }
                    }
                    // navigation: {
                    //     nextEl: '.swiper-button-next',
                    //     prevEl: '.swiper-button-prev',
                    // },
                });
            },
            getPriceRange(array) {
                if (array.length) {
                    var min   = array[0].price,
                        max   = array[0].price;
                    var range = null;
                    array.map((response) => {
                        min = response.price < min ? response.price : min;
                        max = response.price > max ? response.price : max;
                    });
                    min = Number.parseFloat(min).toFixed(2);
                    max = Number.parseFloat(max).toFixed(2);
                    if (min === max) {
                        return "P " + this.numberWithCommas(min);
                    }
                    return "P " + this.numberWithCommas(min) + " - P " + this.numberWithCommas(max);
                }
                return  "P " + "0.00";
            }
        },
        mounted() {
            this.getList()
        }
    }

</script>

<style lang="scss">
    @import "../scss/app.scss";

    .items-on-sale {
        .item-on-sale__swiper {
            position: relative;

            .product-item {
                display: grid;
                grid-template-columns: 1fr;
            }
        }

        .swiper-wrapper {
            position: relative;
        }

        .swiper-button-next,
        .swiper-button-prev {
            width  : 33px;
            height : 33px;
            z-index: 1;
        }

        .swiper-button-next {
            right             : -10px;
            background-image  : url('../assets/svgs/next.svg');
            -webkit-box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            -moz-box-shadow   : 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            box-shadow        : 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            background-color  : #fff;
            border-radius     : 100%;
        }

        .swiper-button-prev {
            left              : -10px;
            background-image  : url('../assets/svgs/prev.svg');
            -webkit-box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            -moz-box-shadow   : 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            box-shadow        : 0px 0px 15px 2px rgba(0, 0, 0, 0.4);
            background-color  : #fff;
            border-radius     : 100%;
        }
    }

</style>
